import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventScheduleDay {
	scheTmCnt: number;
	optCnt: number;
	trv70Cnt: number;
	trv20Cnt: number;
	shopInfoCnt: number;
	scheTrvCnt: number;
	shopCnt: number;
	insuSeq: number;
	optInfo: string;
	atteInfo: string;
	insuTempNm: string;
	rewordId: string;
	evStartDt: string;
	goodsCd: string;
	evCd: string;
	daySeq: number;
	dayNoSeq: number;
	dayNo: number;
	accommCd: string;
	accommNm: string;
	accommNote: string;
	accommYn: string;
	foodB: string;
	foodL: string;
	foodD: string;
	foodBYn: string;
	foodLYn: string;
	foodDYn: string;
	accommInfoId: string;
	dayNote: string;
}

interface EventScheduleTime {
	goodsCd: string;
	dayNo: number;
	daySeq: number;
	dayNoSeq: number;
	cityNm: string;
	cityCd: string;
	viCityNm: string;
	tmNo: number;
	tmSeq: number;
	tmNm: string;
	tmTitle: string;
	tmContent: string;
	flightTm: string;
	trvVideoUrl: string;
	trvVideoTitle: string;
	trvVideoNote: string;
	trvVimeoUrl: string;
	trvVideoThum: string;
	evStartDt: string;
	evArriveDt: string;
	outDayDiff: number;
	inDayDiff: number;
	outDeprtTm: string;
	outArrvTm: string;
	inDeprtTm: string;
	inArrvTm: string;
	outFlightNm: string;
	inFlightNm: string;
	meetAirPlace: string;
	meetAirTm: string;
	meetAirTelNo: string;
	meetAirNote: string;
	trTp: string;
	outDeprtCityNm: string;
	outArrvCityNm: string;
	inDeprtCityNm: string;
	inArrvCityNm: string;
	endInfoImgUrl: string;
	meetAirImgUrl: string;
	meetAirDivi: string;
	meetAirDiviCont: string;
}

interface EventScheduleTrip {
	scheduleDetail: EventScheduleDay[];
	scheduleDetailTm: EventScheduleTime[];
}

/** ```
 * 행사 일정표 일차 데이터
 *   `/pkg/event-schedule/${evCd}/${goodsCd}`
 * parameter
 *   `evCd` 행사코드
 *   `goodsCd` 행사코드
 * ```*/
const key = "useEventScheduleTrip";
const getPath = (evCd: string, goodsCd: string): string | null => {
	if (!evCd || !goodsCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-schedule/${evCd}/${goodsCd}`;
};

/** ```
 * 행사 일정표 일차 데이터
 *   `/pkg/event-schedule/${evCd}/${goodsCd}`
 * parameter
 *   `evCd` 행사코드
 *   `goodsCd` 행사코드
 * ```*/
const useEventScheduleTrip = (
	evCd: string,
	goodsCd: string,
	options?: Partial<UseQueryOptions<Response<EventScheduleTrip>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(evCd, goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd, goodsCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventScheduleTrip;
export {getPath};
export type {EventScheduleTrip, EventScheduleDay, EventScheduleTime};
